const HqNetworks = {
    "0x1":{
      chainId: 1, 
      url:'https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
      name:'Ethereum',
      explorer:'https://etherscan.io/tx'
    },
    "0x3":{
      chainId:'3',
      url:'https://ropsten.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
      name:'Ropsten',
      explorer:'https://ropsten.etherscan.io/tx'
    },
    '0x4':{
      chainId:4,
      url:'https://rinkeby.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
      name:'Rinkeby',
      explorer:'https://rinkeby.etherscan.io/tx'
  
    },
    '0x2a':{
        chainId:42,
        url:'https://kovan.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
        name:'Kovan',
        explorer:'https://kovan.etherscan.io/tx'
    
      },
    '0x38':{
        chainId:56,
        url:'https://bsc-dataseed1.binance.org',
        name:'BSCMain',
        explorer:'https://bscscan.com/tx'
    
    },
    '0x61':{
      chainId:97,
      url:'https://data-seed-prebsc-1-s1.binance.org:8545/',
      name:'BSCTest',
      explorer:'https://testnet.bscscan.com/tx'
  
    },
    '0x7f93':{
        chainId:32659,
        url:'https://mainway.freemoon.xyz/gate/',
        name:'Fusion',
        explorer:'https://fsnex.com/transaction'
    },
    '0xb660':{
        chainId:46688,
        url:'https://testway.freemoon.xyz/gateway',
        name:'FusionTest'
    },
    '0x13881':{
        chainId:80001,
        url:'https://rpc-mumbai.maticvigil.com/',
        name:'Mumbai'
    },
    '0x89':{
        chainId:137,
        url:'https://polygon-mainnet.infura.io/v3/295cce92179b4be498665b1b16dfee34',
        name:'Polygon',
        explorer:'https://polygonscan.com/tx'
    },
    '0x63564c40':{
      chainId:1666600000,
      url:'https://api.s0.t.hmny.io',
      name:'Harmony',
      explorer:'https://explorer.harmony.one/tx',
    },

    '0x80':{
      chainId:128,
      url:'https://http-mainnet.hecochain.com',
      name:'HECO',
      explorer:'https://hecoinfo.com',
    },
    
    
  };
  export default HqNetworks;

  